import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { authService } from "../../../services/api";
import { useNotification } from "../../../components/Notifications/NotificationContext";
import DownsellList from "./DownsellList";
import DownsellForm from "./DownsellForm";
import FormModal from "../../../components/UI/FormModal/FormModal";
import { useSyncBotSelection } from "../../../hooks/useSyncBotSelection";

export default function Downsell() {
    const { botId } = useParams();
    const { showError } = useNotification();

    const [downsells, setDownsells] = useState([]);
    const [revenueSymbol, setRevenueSymbol] = useState('R$');
    const [defaultDelivery, setDefaultDelivery] = useState(null);
    const [editing, setEditing] = useState(null);
    // Começa true: o fetch inicial só dispara depois do primeiro paint (useEffect),
    // então iniciar em false deixava a lista renderizar vazia por um instante
    // ("Nenhum downsell criado") antes do spinner/dados reais aparecerem.
    const [loading, setLoading] = useState(true);
    const [showForm, setShowForm] = useState(false);


    useSyncBotSelection();
    useEffect(() => {
        setShowForm(false);
        setEditing(null);
        if (botId) loadDownsells();
        else setLoading(false);
    }, [botId]);

    // silent=true → não mostra o spinner de tela cheia (evita piscar/subir ao topo
    // no refresh pós-ação); só troca os dados no lugar.
    const loadDownsells = async ({ silent = false } = {}) => {
        try {
            if (!silent) setLoading(true);
            const { data } = await authService.downsell.get_downsell(botId);

            if (data.success) {
                setDownsells(data.downsells);
                setRevenueSymbol(data.revenue_symbol || 'R$');
                setDefaultDelivery(data.downsell_default_delivery || null);
            }
        } catch {
            showError("Erro ao carregar downsells");
        } finally {
            if (!silent) setLoading(false);
        }
    };

    const closeForm = () => {
        setEditing(null);
        setShowForm(false);
    };

    return (
        <>
            <DownsellList
                downsells={downsells}
                loading={loading}
                onEdit={(downsell) => {
                    setEditing(downsell);
                    setShowForm(true);
                }}
                onDelete={() => loadDownsells({ silent: true })}
                onDuplicate={() => loadDownsells({ silent: true })}
                revenueSymbol={revenueSymbol}
                onNew={() => {
                    setEditing(null);
                    setShowForm(true);
                }}
                botId={botId}
                defaultDelivery={defaultDelivery}
                onDefaultDeliveryChange={setDefaultDelivery}
            />

            {/* FORM — modal de criar/editar downsell */}
            <FormModal open={showForm} onClose={closeForm}>
                <DownsellForm
                    botId={botId}
                    editing={editing}
                    onEditingChange={setEditing}
                    onBack={closeForm}
                    onSuccess={() => {
                        closeForm();
                        loadDownsells();
                    }}
                />
            </FormModal>
        </>
    );
}
